// Typelizer digest 5ded9b62ae7baab8b30e96bcd535e7c8
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** POST /c/:company_id/bulk_counterparties */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/bulk_counterparties', {}, options),
    method: 'post',
  }),
}
